import {useCallback, useState} from "react";
import {MODAL_IMAGE_TRANSITION_TIME} from "../../config";
import LightboxActions from "../../../../../redux/Lightbox/actions";
import {useDispatch, useSelector} from "react-redux";

const {
    setCurrentIndex,
} = LightboxActions;

export const useChangeSlide = () => {
    const [movingDirection, setMovingDirection] = useState(null);

    const fileCount = useSelector(state => state.Lightbox.files.length);
    const currentIndex = useSelector(state => state.Lightbox.currentIndex);
    const dispatch = useDispatch();

    const goToPrev = useCallback(() => {
        setMovingDirection('right');
        setTimeout(() => {
            const nextIndex = (currentIndex + fileCount - 1) % fileCount;
            dispatch(setCurrentIndex(nextIndex));
            setMovingDirection(null);
        }, MODAL_IMAGE_TRANSITION_TIME);
    }, [currentIndex, dispatch, fileCount]);

    const goToNext = useCallback(() => {
        setMovingDirection('left');
        setTimeout(() => {
            const nextIndex = (currentIndex + 1) % fileCount;
            dispatch(setCurrentIndex(nextIndex));
            setMovingDirection(null);
        }, MODAL_IMAGE_TRANSITION_TIME);
    }, [currentIndex, dispatch, fileCount]);

    return {
        movingDirection,
        goToPrev,
        goToNext,
    };
};
